/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum OtpSchema {
    '_0' = 0,
    '_1' = 1,
}